<template>
	<div>
		<div class="actorGoalLaneProgress">
			<div class="goalLevelBadge">
				<!-- @vue-expect-error -->
				<img
					style="width: 100%;"
					:src='"/img/unionslabor/icons/goals/" + actorPropertiesGoal.level + ".png"'
					:title="actorPropertiesGoal.level"
				>
			</div>
		</div>
		<div
			v-if="previousActorPropertiesGoal && achievedNotificationVisible"
			:class='(achievedNotificationVisible && previousActorPropertiesGoal) ? "actorGoalNotification fadeInUp" : "hide"'
			v-on:click="toggleAchievedNotification()"
		>
			<div>
				<!-- @vue-expect-error -->
				<img
					style="width: 100px;"
					:src='"/img/unionslabor/icons/goals/" + (parseInt(actorPropertiesGoal.level) - 1) + ".png"'
				>
				<img
					style="width: 50px;"
					src="/img/unionslabor/odd_bits/level_up_arrows.svg"
				>
				<!-- @vue-expect-error -->
				<img
					style="width: 100px;"
					:src='"/img/unionslabor/icons/goals/" + actorPropertiesGoal.level + ".png"'
				>
			</div>
			<h2>Du hast deine Wahlversprechen erfüllt!</h2>
			<p>Deine Beliebtheit steigt um ein Level</p>
			<div class="ulab-button ulab-button-interaction">
				Lass mich weiter Politik machen
			</div>
		</div>
	</div>
</template>
<script>
import { i18n } from "../utils";

export default {
	// Naming - server = srv
	mixins: [i18n],
	props: {
		srvActorPropertiesGoal: Object,
	},
	data: function () {
		return {
			actorPropertiesGoal: this.srvActorPropertiesGoal,
			previousActorPropertiesGoal: null,
			achievedNotificationVisible: false,
			delayedStoreSyncData: null,
		};
	},
	computed: {
		locale: function () {
			return I18n.locale;
		},
	},
	mounted() {
		pp.vue.bus.$on(
			"actorPropertiesGoal-ACHIEVE",
			this.onActorPropertiesGoalAchieved,
		);
	},
	beforeDestroy() {
		pp.vue.bus.$off(
			"actorPropertiesGoal-ACHIEVE",
			this.onActorPropertiesGoalAchieved,
		);
	},
	methods: {
		onActorPropertiesGoalAchieved(res) {
			// @ts-expect-error
			if (res && res.id != this.actorPropertiesGoal.id) {
				// @ts-expect-error
				this.previousActorPropertiesGoal = this.actorPropertiesGoal; // TODO probably deletable, previousActorPropertiesGoal is not used in the actorGoalNotification overlay
				this.toggleAchievedNotification();
				this.$set(this, "actorPropertiesGoal", res);
			}
		},
		toggleAchievedNotification() {
			this.achievedNotificationVisible = !this.achievedNotificationVisible;
		},
	},
};
</script>
